"use client";

import { EyeOff, Heart, Lock, Shield } from "lucide-react";

import { FadeInSection } from "../FadeInSection";
import MainFooter from "../MainFooter";

export default function PrivacyPolicyHero() {
  return (
    <main className="absolute inset-0 flex flex-col overflow-y-auto overflow-x-clip bg-background text-foreground">
      <div className="flex flex-col items-center">
        {/* Hero */}
        <FadeInSection
          as="section"
          className="relative w-full border-b border-foreground/10"
        >
          <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-4 pt-16 pb-10 text-center sm:px-6 md:py-14 lg:min-h-[calc(100dvh-11rem)] lg:px-8 lg:justify-center">
            <Shield className="mt-5 w-12 h-12 text-lime-600 dark:text-lime-400" />
            <h1 className="mt-4 font-PlayfairDisplay text-5xl font-semibold leading-none text-foreground md:text-6xl lg:text-7xl">
              Privacy
              <br />
              <span className="text-lime-600 dark:text-lime-400">Policy</span>
            </h1>
            <p className="mt-6 max-w-2xl font-Cabin text-lg leading-relaxed text-foreground/80 dark:text-foreground/85 md:text-xl">
              Transparency without surveillance.
              <br />
              Accountability without compromise.
            </p>
          </div>
        </FadeInSection>

        {/* Statements */}
        <FadeInSection
          as="section"
          className="w-full border-b border-foreground/10 px-4 py-16 sm:px-6 md:py-20 lg:px-8"
        >
          <div className="mx-auto flex w-full max-w-4xl flex-col gap-16">
            <div className="flex flex-col md:flex-row items-start gap-8">
              <EyeOff size={28} className="shrink-0 text-foreground/50 mt-1" />
              <div>
                <h2 className="font-PlayfairDisplay text-3xl font-semibold md:text-4xl mb-4">
                  No analytics. No data collection.
                </h2>
                <p className="font-Cabin text-lg leading-relaxed text-foreground/70">
                  We don&apos;t track visits, record sessions, or build profiles.
                  What you read stays yours.
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row items-start gap-8">
              <Heart size={28} className="shrink-0 text-foreground/50 mt-1" />
              <div>
                <h2 className="font-PlayfairDisplay text-3xl font-semibold md:text-4xl mb-4">
                  Because we are like you.
                </h2>
                <p className="font-Cabin text-lg leading-relaxed text-foreground/70">
                  Research and transparency don&apos;t require surveillance. We
                  built Stone the way we&apos;d want it built for ourselves.
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row items-start gap-8">
              <Shield size={28} className="shrink-0 text-foreground/50 mt-1" />
              <div>
                <h2 className="font-PlayfairDisplay text-3xl font-semibold md:text-4xl mb-4">
                  You are not accountable.
                </h2>
                <p className="font-Cabin text-lg leading-relaxed text-foreground/70">
                  We make research valuable by making it visible — not by
                  monitoring who views it. Visiting this service should never
                  create a record about you.
                </p>
              </div>
            </div>
          </div>
        </FadeInSection>

        {/* Cookie */}
        <FadeInSection
          as="section"
          className="w-full px-4 py-16 sm:px-6 md:py-20 lg:px-8"
        >
          <div className="mx-auto flex w-full max-w-3xl flex-col items-center gap-6 text-center">
            <Lock size={28} className="text-lime-600 dark:text-lime-400" />
            <h3 className="font-PlayfairDisplay text-3xl font-semibold md:text-4xl">
              One cookie, one purpose.
            </h3>
            <p className="font-Cabin text-lg leading-relaxed text-foreground/70 max-w-xl">
              We store a single cookie to remember your display preference —
              light or dark mode. That&apos;s it. No tracking, no third parties.
            </p>
          </div>
        </FadeInSection>

        <MainFooter />
      </div>
    </main>
  );
}
